export default __webpack_public_path__ + "d3bbf55.png";